module.exports = __webpack_public_path__ + "img/W7001-tran.9d67833f.jpg";